<template>
  <section>
    {{ result }}
  </section>
</template>
<script>
export default {
  name: 'get_car_info',

  data () {
    return {
      route_id: null,
      result: '',
    }
  },

  mounted () {
    this.api();
  },

  methods: {
    //데이터 가져오기
    api: function(){
      var url_string = window.location.href;
      var url = new URL(url_string);
      this.route_id = url.searchParams.get("route_id");
      if(this.route_id == null) {
        return;
      }

      var post_data = {route_id: this.route_id}
      this.$axios.post('/api/api_get_car_info', post_data).then(res => {
        console.log(res.data.result[0]);
        this.result = res.data.result[0];
      /*
       * this.anychart3(res.data.rows); this.anychart4(res.data.rows);
       */
      });
    },
  },
}
</script>
<style>
</style>